import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
  // 路由重定向
  // 首页
  {
    path: '/',
    redirect: '/Home',
    hidden: true,
    meta: {
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  // 首页
  {
    path: '/Home',
    name: 'Home',
    component: () => import('../views/Home/index.vue'),
    meta: {
      name: 'Home',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // about-cgsi
  {
    path: '/about-us/about-cgsi',
    name: 'about-cgsi',
    component: () => import('../views/About-Cgsi/index.vue'),
    meta: {
      name: 'about-cgsi',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // aicn
  {
    path: '/sustainability/aicn',
    name: 'aicn',
    component: () => import('../views/Aicn/index.vue'),
    meta: {
      name: 'aicn',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  // awards-and-accolades
  {
    path: '/about-us/awards-and-accolades',
    name: 'awards-and-accolades',
    component: () => import('../views/AwardsAndAccolades/index.vue'),
    meta: {
      name: 'awards-and-accolades',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // careers
  {
    path: '/careers',
    name: 'careers',
    component: () => import('../views/Careers/index.vue'),
    meta: {
      name: 'careers',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // corporate-governance
  {
    path: '/about-us/corporate-governance',
    name: 'corporate-governance',
    component: () => import('../views/CorporateGovernance/index.vue'),
    meta: {
      name: 'corporate-governance',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // investors-information
  {
    path: '/about-us/investors-information',
    name: 'investors-information',
    component: () => import('../views/InvestorsInformation/index.vue'),  
    meta: {
      name: 'investors-information',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // little-galaxians
  {
    path: '/about-us/little-galaxians',
    name: 'little-galaxians',
    component: () => import('../views/LittleGalaxians/index.vue'),
    meta: {
      name: 'little-galaxians',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // insights
  {
    path: '/insights',
    name: 'insights',
    component: () => import('../views/Insights/index.vue'),
    meta: {
      name: 'insights',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // insights 子页
  {
    path: '/insights/:id',
    name: 'insightsarticle',
    component: () => import('../views/Insights/Article/index.vue'),
    props: true,
    meta: {
      name: 'insightsarticle',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // campaigns
  {
    path: '/campaigns',
    name: 'campaigns',
    component: () => import('../views/Campaigns/index.vue'),
    meta: {
      name: 'campaigns',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // campaigns 子页
  {
    path: '/campaigns/:id',
    name: 'campaignsarticle',
    component: () => import('../views/Campaigns/Article/index.vue'),
    props: true,
    meta: {
      name: 'campaignsarticle',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // events
  {
    path: '/events',
    name: 'events',
    component: () => import('../views/Events/index.vue'),
    meta: {
      name: 'events',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // events 子页
  {
    path: '/events/:id',
    name: 'eventsarticle',
    component: () => import('../views/Events/Article/index.vue'),
    props: true,
    meta: {
      name: 'eventsarticle',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // news
  {
    path: '/news',
    name: 'news',
    component: () => import('../views/News/index.vue'),
    meta: {
      name: 'news',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // news 子页
  {
    path: '/news/:id',
    name: 'newsarticle',
    component: () => import('../views/News/Article/index.vue'),
    props: true,
    meta: {
      name: 'newsarticle',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // CareersListing
  {
    path: '/career',
    name: 'CareersListing',
    component: () => import('../views/CareersListing/index.vue'),
    meta: {
      name: 'CareersListing',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // CareersListing 子页
  {
    path: '/career/:id',
    name: 'careerslistingarticle',
    component: () => import('../views/CareersListing/Article/index.vue'),
    props: true,
    meta: {
      name: 'careerslistingarticle',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // csr
  {
    path: '/sustainability/csr',
    name: 'csr',
    component: () => import('../views/Csr/index.vue'),
    meta: {
      name: 'csr',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // csr 子页
  {
    path: '/sustainability/csr/:id',
    name: 'csrarticle',
    component: () => import('../views/Csr/Article/index.vue'),
    props: true,
    meta: {
      name: 'csrarticle',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // contact-us
  {
    path: '/contact-us',
    name: 'contact-us',
    component: () => import('../views/ContactUs/index.vue'),
    meta: {
      name: 'contact-us',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // contact-us 子页
  {
    path: '/contact-us/:id',
    name: 'contact-usarticle',
    component: () => import('../views/ContactUs/Article/index.vue'),
    props: true,
    meta: {
      name: 'contact-usarticle',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // ipo
  {
    path: '/our-offerings/ipo',
    name: 'ipo',
    component: () => import('../views/Ipo/index.vue'),
    meta: {
      name: 'ipo',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // ipo 子页
  {
    path: '/our-offerings/ipo/:id',
    name: 'ipoarticle',
    component: () => import('../views/Ipo/Article/index.vue'),
    props: true,
    meta: {
      name: 'ipoarticle',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // ipo 子页
  {
    path: '/info/notices/ipo/:id',
    name: 'ipoIarticle',
    component: () => import('../views/Ipo/IArticle/index.vue'),
    props: true,
    meta: {
      name: 'ipoIarticle',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // info
  {
    path: '/info/:id',
    name: 'info',
    component: () => import('../views/Info/index.vue'),
    props: true,
    meta: {
      name: 'info',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // pricings
  {
    path: '/our-offerings/pricings/:id',
    name: 'pricings',
    component: () => import('../views/Pricings/index.vue'),
    props: true,
    meta: {
      name: 'pricings',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // platform
  {
    path: '/our-offerings/platform/:id',
    name: 'platform',
    component: () => import('../views/Platform/index.vue'),
    props: true,
    meta: {
      name: 'platform',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // products
  {
    path: '/our-offerings/products/:id',
    name: 'products',
    component: () => import('../views/Products/index.vue'),
    props: true,
    meta: {
      name: 'products',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // etfs
  {
    path: '/etfs/:id',
    name: 'etfs',
    component: () => import('../views/Etfs/index.vue'),
    props: true,
    meta: {
      name: 'etfs',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  {
    path: '/events/exclusive/:id',
    name: 'alternative',
    component: () => import('../views/Events/Alternative/index.vue'),
    props: true,
    meta: {
      name: 'alternative',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // platform-solutions
  {
    path: '/our-offerings/platform-solutions',
    name: 'platform-solutions',
    component: () => import('../views/PlatformSolutions/index.vue'),
    meta: {
      name: 'platform-solutions',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // notices
  {
    path: '/notices',
    name: 'notices',
    component: () => import('../views/Notices/index.vue'),
    meta: {
      name: 'notices',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // our-business
  {
    path: '/our-business',
    name: 'our-business',
    component: () => import('../views/OurBusiness/index.vue'),
    meta: {
      name: 'our-business',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    }
  },
  // our-commitment
  {
    path: '/sustainability/our-commitment',
    name: 'our-commitment',
    component: () => import('../views/OurCommitment/index.vue'),
    meta: {
      name: 'our-commitment',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // our-heritage
  {
    path: '/about-us/our-heritage',
    name: 'our-heritage',
    component: () => import('../views/OurHeritage/index.vue'),
    meta: {
      name: 'our-heritage',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // our-offices
  {
    path: '/about-us/our-offices',
    name: 'our-offices',
    component: () => import('../views/OurOffices/index.vue'),
    meta: {
      name: 'our-offices',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // people-and-leadership
  {
    path: '/about-us/people-and-leadership',
    name: 'people-and-leadership',
    component: () => import('../views/PeopleAndLeadership/index.vue'),
    meta: {
      name: 'people-and-leadership',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },

  // 全网搜索
  {
    path: '/search-result',
    name: 'search-result',
    component: () => import('../views/Search-Result/index.vue'),
    meta: {
      name: 'search-result',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // Help
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/Help/index.vue'),
    meta: {
      name: 'help',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
  },
  // Help 子页
  {
    path: '/help/:id',
    name: 'Help-Centre-Question',
    component: () => import('../views/Help/Help-Centre-Question/index.vue'),
    props: true,
    meta: {
      name: 'Help-Centre-Question',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },
    beforeEnter: (to, from, next) => {
      next();
    }
  },
  // 语言转换
  {
    path: '/change-language/:lng',
    name: 'change-language',
    component: () => import('../components/ChangeLanguage.vue'),
    props: true
  },
  // 404
  {
    path: '/404',
    name: '404',
    component: () => import('../views/Error-404/index.vue'),
    meta: {
      name: '404',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },

  },
  {
    path: '*',
    name: '404',
    component: () => import('../views/Error-404/index.vue'),
    meta: {
      name: '404',
      title: '',
      content: {
        keywords: '',
        description: ''
      }
    },

  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


router.beforeEach((to, from, next) => {
  // 确保每个路由都有 lang=TH 参数
  if (to.path === '/our-business' && process.env.VUE_APP_REGION !== 'IN') {
    next('/404')
    return // 提前返回，避免继续执行下面的代码
  }

  if (to.path === '/sustainability/aicn' && process.env.VUE_APP_REGION !== 'IN') {
    next('/404')
    return // 提前返回，避免继续执行下面的代码
  }

  if (to.path === '/campaigns' && process.env.VUE_APP_REGION == 'IN') {
    next('/404')
    return // 提前返回，避免继续执行下面的代码
  }
  if (to.name === 'campaignsarticle' && process.env.VUE_APP_REGION == 'IN') {
    next('/404')
    return // 提前返回，避免继续执行下面的代码
  }
  if (to.path === '/sustainability/csr' && process.env.VUE_APP_REGION == 'IN') {
    next('/404')
    return // 提前返回，避免继续执行下面的代码
  }
  if (to.name === 'csrarticle' && process.env.VUE_APP_REGION == 'IN') {
    next('/404')
    return // 提前返回，避免继续执行下面的代码
  }
  if (to.name === 'platform' && process.env.VUE_APP_REGION == 'IN') {
    next('/404')
    return // 提前返回，避免继续执行下面的代码
  }

  if (to.path === '/help' && process.env.VUE_APP_REGION == 'IN') {
    next('/404')
    return // 提前返回，避免继续执行下面的代码
  }

  if (to.name === 'Help-Centre-Question' && process.env.VUE_APP_REGION == 'IN') {
    next('/404')
    return // 提前返回，避免继续执行下面的代码
  }

  console.log(to.name);



  if (!to.query.lang) {
    let lang = process.env.VUE_APP_LANGUAGE1
    let Language = localStorage.getItem("Language") || 2
    if (localStorage.getItem("Language") != "" && localStorage.getItem("Language") != undefined) {
      if (Language == 1) {
        lang = process.env.VUE_APP_LANGUAGE1
      } else {
        lang = process.env.VUE_APP_LANGUAGE1
      }
    }
    if (to.hash) {

      next({
        path: to.path,
        query: { ...to.query, lang: lang },
        hash: to.hash
      })
    } else {
      next({
        path: to.path,
        query: { ...to.query, lang: lang }
      })
    }

  } else {
    next()
  }
})

router.afterEach((to, from) => {
  // Vue.nextTick(() => {
  //   // 执行你的 GlobalTeference 函数
  //   if (Vue.prototype._$.GlobalTeference) {
    
  //     setTimeout(() => {

  //       Vue.prototype._$.GlobalTeference();

  //     }, 3000);

  //   }
  // });

});

export default router
